export const METRICS_TOUR_TARGET_IDS = {
  filters: 'metrics-tour-filters',
} as const;

/** Wraps the open Analytics tab (ANLT-01), for the tour's second step. */
export const ANALYTICS_PANEL_ATTRIBUTE = 'data-analytics-panel';

export const METRICS_TOUR_SELECTORS = {
  filters: `#${METRICS_TOUR_TARGET_IDS.filters}`,
  // The first help icon of the open tab (Resumo: the Vendas card's), so the
  // step never points at a card of another tab.
  firstMetricHelpIcon: `[${ANALYTICS_PANEL_ATTRIBUTE}] button[aria-controls="analytics-help-panel"]`,
} as const;
